import { createContext, useContext, useMemo, useState } from "react";

const Ctx = createContext(null);
export const useCart = () => useContext(Ctx);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState({});
  const [open, setOpen] = useState(false);

  const add = (item) => {
    setItems((m) => {
      const cur = m[item.name];
      return { ...m, [item.name]: { ...item, qty: (cur?.qty || 0) + 1 } };
    });
    setOpen(true);
  };

  const setQty = (name, qty) =>
    setItems((m) => {
      const copy = { ...m };
      if (qty <= 0) delete copy[name];
      else copy[name] = { ...copy[name], qty };
      return copy;
    });

  const clear = () => setItems({});

  const { count, total, list } = useMemo(() => {
    const list = Object.values(items);
    return {
      list,
      count: list.reduce((a, i) => a + i.qty, 0),
      total: list.reduce((a, i) => a + i.qty * i.price, 0),
    };
  }, [items]);

  return (
    <Ctx.Provider value={{ list, count, total, add, setQty, clear, open, setOpen }}>
      {children}
    </Ctx.Provider>
  );
};
